// Angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// Afidium
import { ViewsService } from 'libraries/view/views.service';
import { WORDING } from './config/wording';
import { IBreadcrumbItem } from 'libraries/service/breadcrumb/IBreadcrumbItem';
import { AppRootService } from 'app/shared/services/app-root/app-root-service';
import { ProcessingEmailService } from './services/processing-email.service';
import { MailBreadcrumbService } from './services/email-breadcrumb.service';

import { SashaPageComponent } from '../sasha-page.component';
import { INotification, NotificationType } from 'libraries/interfaces/INotification';
import { IEmail, IEmailRequest } from 'app_sasha/shared/interfaces/IEmail';
import { ProcessingEmailResourceService } from 'app_sasha/shared/resources/processing-email-resource/processing-email-resource.service';
import { TitleService } from 'app_sasha/shared/services/title/title.service';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";

@Component({
    selector: 'processing-email',
    template: `
        <div class="app-wrapper app-sasha">
            <breadcrumb [items]="breadcrumbItems"></breadcrumb>

            <template-list
                [templates]="emailTemplates"
                [isLoading]="emailTemplateLoader.active"
                (onSelectTemplate)="selectTemplate($event)"
                (onGoToFormView)="goToFormView()">
                <notification *ngIf="notification.active" [type]="notification.type">
                    {{ notification.message }}
                </notification>
            </template-list>
        </div>
    `
})
export class ProcessingEmailComponent extends SashaPageComponent implements OnInit {
    public wording: ILabels = WORDING;

    public emailTemplates: IEmail[] = [];
    public selectedEmailTemplate: IEmail;
    public emailTemplateLoader: {
        active: boolean,
        message: string
    } = {
            active: false,
            message: null
        };

    public mailValues: IEmail;

    public notification: INotification = {
        active: false,
        message: null,
        type: NotificationType.Error
    };

    public breadcrumbItems: IBreadcrumbItem[] = [];

    constructor(
        protected viewsService: ViewsService,
        private readonly router: Router,
        private readonly processingEmailService: ProcessingEmailService,
        private readonly mailBreadcrumbService: MailBreadcrumbService,
        private readonly processingEmailResourceService: ProcessingEmailResourceService,
        appRootService: AppRootService,
        private readonly titleService: TitleService,
        private readonly errorTracingService: ErrorTracingService,
    ) {
        super(viewsService, appRootService);
    }

    public ngOnInit(): void {
        // Initialize breadcrumb
        this.breadcrumbItems = this.mailBreadcrumbService.breadcrumbList();
        this.titleService.setTitle(
            Yii.t("wui-sasha-js", "Modèles d'email"),
        );

        // Get email model list
        this.processingEmailResourceService.getEmailTemplates()
            .subscribe(
                (emailTemplates: IEmail[]): void => {
                    this.emailTemplates = emailTemplates;
                },
                (error: Error): void => {
                    this.errorTracingService.captureException(error);
                    this.notification = {
                        active: true,
                        type: NotificationType.Error,
                        message: `${this.wording.getEmailTemplatesError} ${error}`
                    };
                }
            );
    }

    /** Select template then change route */
    public selectTemplate(selectedTemplate: IEmailRequest): void {
        this.emailTemplateLoader = {
            active: true,
            message: 'this.wording.emailTemplateLoading'
        };

        this.processingEmailResourceService.getEmailTemplate(
            selectedTemplate.id
        ).subscribe(
            (emailTemplate: IEmail): void => {
                this.processingEmailService.form = emailTemplate;
            },
            (error: Error): void => {
                this.errorTracingService.captureException(error);
                this.notification = {
                    active: true,
                    type: NotificationType.Error,
                    message: this.wording.getOneEmailTemplate
                };
            },
            async () => {
                this.emailTemplateLoader.active = false;
                await this.router.navigate(['/sasha/processing-email/form'], {
    queryParamsHandling: 'preserve'
});
            }
        );
    }

    public async goToFormView(): Promise<void> {
        this.processingEmailService.form = null;
        await this.router.navigate(['/sasha/processing-email/form'], {
    queryParamsHandling: 'preserve'
});
    }
}
